import React, { useEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import InitPage from "./init/InitPage";
import LoadingPage from "./loading/LoadingPage";
import MaintenancePage from "./error/MaintenancePage";
import ExpiredPage from "./error/ExpiredPage";
import IncomingPage from "./IncomingPage";
import LandingPage from "./landing/LandingPage";
import ChatPage from "./chat/ChatPage";
import ProductSearchPage from "./search/ProductSearchPage";
import ProductDetailPage from "./search/ProductDetailPage";
import UniverseClubPage from "./membership/UniverseClubPage";
import GiftCardPage from "./giftCard/GiftCardPage";
import RefundPage from "./refund/RefundPage";
import LostItemsSearchPage from "./lostFoundCenter/LostItemsSearchPage";
import AfterServicePage from "./afterService/AfterServicePage";
import RegistLostItemPage from "./lostFoundCenter/RegistLostItemPage";
import RegistCompletePage from "./lostFoundCenter/RegistCompletePage";
import LostFoundCenterPage from "./lostFoundCenter/LostFoundCenterPage";
import RegistUnavailblePage from "./error/unavailable/RegistUnavailblePage";
import UnavailableInfoPage from "./error/unavailable/UnavailableInfoPage";
import NoticePage from "./notice/NoticePage";
import SelectBranchWithMapPage from "./selectBranch/SelectBranchWithMapPage";
import EventsPage from "./events/EventsPage";
import ExitPage from "./exit/ExitPage";
import StoreNewsPage from "./storeNews/StoreNewsPage";
import BlockPage from "./error/BlockPage";
import { ErrorBoundary } from "react-error-boundary";
import ReactGA from "react-ga4";
import { useSelector } from "react-redux";
import useSession from "#src/hooks/sesseion/useSession.js";
import useReactGASend from "#src/hooks/useReactGASend.js";
import CheckinPage from "./checkin/CheckinPage";
import TicketPage from "./ticket/TicketPage";
import MembershipPage from "./membership/MembershipPage";
import GamePage from "./game/GamePage";
import GoodsPage from "./goods/GoodsPage";
import ParkingPage from "./parking/ParkingPage";
import LostFoundPage from "./lostFound/LostFoundPage";
import IllegalTicketPage from "./illegalTickets/IllegalTicketPage";
import FaqPage from "./faq/FaqPage";

const ErrorBoundaryComponent = ({ error }) => {
  const { makeEventTrackFn } = useReactGASend();
  // 에러 발생 시 /service-unavailable 페이지로 리다이렉트
  const navigate = useNavigate();
  useEffect(() => {
    if (error) {
      makeEventTrackFn({ category: "event", action: "장애페이지 06", body: { errorMessage: error }, });
      navigate("/landing");
      window.location.reload();
    }
  }, [error]);

  return null;
};

const RoutesSetup = () => {
  useSession(); //세션 관리 코드

  return (
    <Routes>
      <Route path="/init" element={<InitPage />} />
      <Route path="/flyers" element={<EventsPage />} />
      <Route
        path="*"
        element={
          <ErrorBoundary FallbackComponent={ErrorBoundaryComponent}>
            <Routes>
              <Route path="/" element={<IncomingPage />} />
              <Route path="/loading" element={<LoadingPage />} />
              <Route path="/landing" element={<LandingPage />} />
              <Route path="/chat/:agent?" element={<ChatPage />} />
              <Route path="/expired" element={<ExpiredPage />} />
              <Route path="/maintenance" element={<MaintenancePage />} />
              <Route path="/search" element={<ProductSearchPage />} />
              <Route path="/search/:product?" element={<ProductDetailPage />} />
              <Route path="/lost" element={<LostFoundCenterPage />} />
              <Route path="/lost/found" element={<LostItemsSearchPage />} />
              <Route
                path="/lost/register-lost-item"
                element={<RegistLostItemPage />}
              />
              <Route
                path="/lost/register-completed"
                element={<RegistCompletePage />}
              />
              <Route path="/universe-club" element={<UniverseClubPage />} />
              <Route path="/gift-card" element={<GiftCardPage />} />
              <Route path="/refund" element={<RefundPage />} />
              <Route path="/after-service" element={<AfterServicePage />} />
              <Route
                path="/service-unavailable"
                element={<UnavailableInfoPage />}
              />
              <Route
                path="/service-unavailable/contact-us"
                element={<RegistUnavailblePage />}
              />
              <Route path="/notice" element={<NoticePage />} />
              <Route path="/map" element={<SelectBranchWithMapPage />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/store-news" element={<StoreNewsPage />} />
              <Route path="/exit" element={<ExitPage />} />
              <Route path="/block" element={<BlockPage />} />
              <Route path="/checkin" element={<CheckinPage />} />
              <Route path="/ticket" element={<TicketPage />} />
              <Route path="/membership" element={<MembershipPage />} />
              <Route path="/game" element={<GamePage />} />
              <Route path="/goods" element={<GoodsPage />} />
              <Route path="/parking" element={<ParkingPage />} />
              <Route path="/lostfound" element={<LostFoundPage />} />
              <Route path="/illigal-tickets" element={<IllegalTicketPage />} />
              <Route path="/faq" element={<FaqPage />} />              
            </Routes>
          </ErrorBoundary>
        }
      />
    </Routes>
  );
};

export default RoutesSetup;
